import enGB from './en_GB.json';
import frFR from './fr_FR.json';

const locales = {
    en_GB: enGB,
    fr_FR: frFR,
};

export default locales;
